import { connect } from 'react-redux';

import {
  getProcessedAltToursCount,
  getTotalAltToursCount,
  getIsActualizeAlternativesFinished,
  getIsPriceFell,
  getCheapestPackagePriceWithAlternatives,
  isAltActualizationDoneSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { setFlightsProgressBarIsSticky } from 'checkout/store/actions/view';
import { cheapestTOExtrasTotalPriceSelector } from 'checkout/store/selectors/services';
import {
  cheapestFlightSelector,
  flightsCountSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import {
  getIsMobile,
  getIsWhitelabel,
  getMobilePlatform,
} from 'src/store/view/selectors';
import FlightsProgressbar from './FlightsProgressbar';

const mapStateToProps = (state) => ({
  isPriceFell: getIsPriceFell(state),
  cheapestPrice:
    cheapestTOExtrasTotalPriceSelector(state) +
    getCheapestPackagePriceWithAlternatives(state) +
    (cheapestFlightSelector(state)?.back[0].fuel_charge || 0),
  currentToursCount: getProcessedAltToursCount(state),
  flightsCount: flightsCountSelector(state),
  totalToursCount: getTotalAltToursCount(state),
  isFetchingDone: getIsActualizeAlternativesFinished(state),
  isAltActualizationFinished: isAltActualizationDoneSelector(state),
  isMobile: getIsMobile(state),
  isWhitelabel: getIsWhitelabel(state),
  platform: getMobilePlatform(state),
});

const mapDispatchToProps = (dispatch) => ({
  setStickyProgressbar: (progressbarState) =>
    dispatch(setFlightsProgressBarIsSticky(progressbarState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlightsProgressbar);
